export default "__VITE_ASSET__DdMBIgm9__"